import { render, staticRenderFns } from "./ProjectNotFound.vue?vue&type=template&id=6783374b&scoped=true&"
var script = {}
import style0 from "./ProjectNotFound.vue?vue&type=style&index=0&id=6783374b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6783374b",
  null
  
)

export default component.exports